export default __webpack_public_path__ + "static/media/ufc-logo.3fa532a1.png";